function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { CurrencyInput } from "../../../../helperComponents";
import { formatValue, getSeparatorByCurrency } from "../../../../utils/currency";
import { CurrencyTypes } from "../../../../utils/data";
import { claimStatusOptions } from "../utils";

var getClaimStatusOption = function getClaimStatusOption(value) {
  return claimStatusOptions.find(function (option) {
    return option.value === value;
  });
};

var Step1 = function Step1(props) {
  var _loadedClaim$document;

  var claim = props.claim,
      onChangeClaim = props.onChangeClaim,
      poliza = props.poliza,
      loadedClaim = props.loadedClaim;
  var currencyFormat = getSeparatorByCurrency(poliza.currency);
  var decimalFormat = getSeparatorByCurrency(CurrencyTypes.PERCENTAGE);
  return /*#__PURE__*/React.createElement("div", {
    className: "step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N\xFAmero de Siniestro"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.claim_number,
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        claim_number: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Fecha de Denuncia"), /*#__PURE__*/React.createElement(DatePicker, {
    showIcon: true,
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    placeHolder: "dd-MM-yyyy",
    selected: claim.request_date,
    onChange: function onChange(item) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        request_date: item
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Fecha y Hora del Siniestro"), /*#__PURE__*/React.createElement(DatePicker, {
    showIcon: true,
    className: "form-control",
    dateFormat: "dd-MM-yyyy HH:mm",
    placeHolder: "dd-MM-yyyy",
    timeFormat: "HH:mm",
    selected: claim.claim_date,
    showTimeInput: true,
    onChange: function onChange(item) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        claim_date: item
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Provisi\xF3n"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: currencyFormat.currency,
    defaultValue: claim.forecast_price,
    onValueChange: function onValueChange(value) {
      return onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        forecast_price: formatValue(value, decimalFormat.decimalLimit)
      }));
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Lugar"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.address || "",
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        address: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Estado Siniestro"), /*#__PURE__*/React.createElement(Select, {
    options: claimStatusOptions,
    value: getClaimStatusOption(claim.status),
    isSearchable: true,
    isClearable: true,
    placeholder: "Selecciona estado del siniestro...",
    onChange: function onChange(item) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        status: item.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Cobertura"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.coverage || "",
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        coverage: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Indemnizaci\xF3n final"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: currencyFormat.currency,
    defaultValue: claim.final_compensation,
    onValueChange: function onValueChange(value) {
      return onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        final_compensation: formatValue(value, decimalFormat.decimalLimit)
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 d-flex align-items-center",
    style: {
      marginTop: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    checked: !!claim.paid,
    onChange: function onChange(e) {
      return onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        paid: e.target.checked
      }));
    },
    id: "claim-paid"
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-check-label",
    htmlFor: "claim-paid"
  }, "Pagado"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 d-flex align-items-center",
    style: {
      marginTop: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    checked: !!claim.firefighters,
    onChange: function onChange(e) {
      return onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        firefighters: e.target.checked
      }));
    },
    id: "claim-firefighters"
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-check-label",
    htmlFor: "claim-firefighters"
  }, "Bomberos"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 d-flex align-items-center",
    style: {
      marginTop: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    checked: !!claim.police,
    onChange: function onChange(e) {
      return onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        police: e.target.checked
      }));
    },
    id: "claim-police"
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-check-label",
    htmlFor: "claim-police"
  }, "Carabineros")))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/React.createElement("label", null, "Descripci\xF3n"), /*#__PURE__*/React.createElement("textarea", {
    className: "form-control inputDescription",
    rows: 10,
    value: claim.description || "",
    onChange: function onChange(event) {
      return onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        description: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", null, "Archivos Adjuntos"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    accept: "application/pdf",
    type: "file",
    multiple: true,
    onChange: function onChange(event) {
      return onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        document: event.target.files[0]
      }));
    }
  }), (loadedClaim === null || loadedClaim === void 0 ? void 0 : (_loadedClaim$document = loadedClaim.document) === null || _loadedClaim$document === void 0 ? void 0 : _loadedClaim$document.name) && /*#__PURE__*/React.createElement("a", {
    href: loadedClaim.document.url
  }, loadedClaim.document.name))))));
};

export default Step1;